"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrostfallAbilityHandler = exports.FrostfallActorAbilityFactory = exports.FrostfallAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AttributeType_1 = require("../../core/enums/AttributeType");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class FrostfallAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Frostfall;
        this.__typeName = "Frostfall";
    }
}
exports.FrostfallAbilityArgs = FrostfallAbilityArgs;
let FrostfallActorAbilityFactory = class FrostfallActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Frostfall", "OneEnemies", 4);
    }
};
FrostfallActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Frostfall")
], FrostfallActorAbilityFactory);
exports.FrostfallActorAbilityFactory = FrostfallActorAbilityFactory;
let FrostfallAbilityHandler = class FrostfallAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        const level = container.getLevel(ability.invokerId);
        const focus = container.getAttributeScore(ability.invokerId, AttributeType_1.AttributeType.Focus);
        const reduceAttributesBy = level * 3 + Math.round(focus * .1);
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "magic",
            targetId,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Frost", 90)
            ],
            onHitOrMiss: (sequence, { hit }) => {
                sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "RainOfIceLances"));
            },
            onHit: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_2.LinkedEffectsEffectArgs([
                        AttributeType_1.AttributeType.Power,
                        AttributeType_1.AttributeType.Focus,
                        AttributeType_1.AttributeType.Will,
                        AttributeType_1.AttributeType.Toughness,
                    ].map(attribute => new core_2.MaxAttributeDecreaseEffectArgs(attribute, reduceAttributesBy)), true)
                });
            },
        });
    }
};
FrostfallAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Frostfall)
], FrostfallAbilityHandler);
exports.FrostfallAbilityHandler = FrostfallAbilityHandler;
